/** Lo que dice el consumo: el contador, los pies de turno y la pantalla de Work. */
export const USAGE_TEXTS = {
  breakdown: {
    input: "Entrada",
    cachedInput: "Entrada leída de caché",
    cacheWriteInput: "Entrada escrita en caché",
    output: "Salida",
    cost: (cost: string) => `Coste: ${cost}`,
  },
  conversation: {
    title: "Esta conversación",
    unpriced: (tokens: string) => `${tokens} tokens · sin precio`,
  },
  turn: {
    input: (tokens: string) => `${tokens} entrada`,
    cache: (tokens: string) => ` · ${tokens} caché`,
    output: (tokens: string) => `${tokens} salida`,
    title: "Este turno",
    titleWithModel: (model: string) => `Este turno · ${model}`,
    expensive: (threshold: string) =>
      `Turno caro: pasó de ${threshold} tokens de entrada`,
    heaviest: " · lo que más pesó: ",
  },
  meter: {
    tokens: (tokens: string) => `${tokens} tokens`,
    ariaLabel: (label: string) => `Consumo de este mes: ${label}`,
    error: (message: string) => `No se pudo leer el consumo: ${message}`,
    reading: "Leyendo el consumo…",
    noData: "El API no ha devuelto el consumo.",
    today: (tokens: string) => `Hoy: ${tokens} tokens · `,
    estimated:
      "Estimado con el catálogo de precios. Pulsa para ver el detalle.",
    month: (name: string) => `Este mes (${name})`,
  },
  chart: {
    costLabel: "Gráfico del coste estimado por día",
    tokensLabel: "Gráfico de tokens por día",
    costName: "Coste estimado",
    tokensName: "Tokens",
    tooltipTokens: (tokens: string) => `${tokens} tokens`,
  },
  panel: {
    wholeYear: (year: string) => `Todo ${year}`,
    introAfterPeriod: ". Todos los costes son ",
    introStrong: "estimados",
    introEnd:
      " con el catálogo de precios de abajo; la factura del proveedor es la que manda.",
    readError: "No se pudo leer el consumo",
    loading: "Cargando…",
    empty: "En este periodo no se le pidió nada a ningún modelo.",
    columns: {
      input: "Entrada",
      cache: "Caché",
      output: "Salida",
      cost: "Coste estimado",
      conversation: "Conversación",
      task: "Tarea",
      model: "Modelo",
      day: "Día",
      cacheRead: "Lectura de caché",
      cacheWrite: "Escritura en caché",
      source: "Origen",
      validFrom: "Vigente desde",
    },
    deletedConversation: "Conversación borrada",
    manual: "A mano",
    synced: "Sincronizado",
    stats: {
      cost: "Coste estimado",
      tokens: "Tokens",
      calls: "Llamadas al modelo",
      unpriced: "Sin precio conocido",
      none: "Ninguna",
      unpricedCalls: (count: string) => `${count} llamadas`,
      backfilled: (count: string, one: boolean) =>
        `Estimado incompleto: ${count} ${
          one ? "turno anterior" : "turnos anteriores"
        } al libro, sin escritura de caché.`,
    },
    daily: {
      cost: "Coste estimado por día",
      tokens: "Tokens por día (sin precio conocido)",
      viewChart: "Ver gráfico",
      viewTable: "Ver tabla",
      unpricedDays: (days: number) =>
        days === 1 ? "1 día sin barra" : `${String(days)} días sin barra`,
      unpricedDaysNote:
        ": no hay precio conocido para lo que se gastó. No es cero; los tokens están en la tabla.",
      loadingChart: "Cargando gráfico…",
    },
    byConversation: "Por conversación",
    mostExpensiveFirst: "las más caras primero",
    viewAll: (hidden: string) => `Ver todas (${hidden} más)`,
    byTask: "Por tarea",
    byModel: "Por modelo",
    prices: {
      title: "Precios de los modelos (US$ por millón de tokens)",
      neverSynced: "Nunca sincronizado",
      lastSync: (date: string) => `Última sincronización: ${date}`,
      failed: " · falló",
      syncing: "Sincronizando…",
      sync: "Sincronizar",
      onlyUsed: "Ver solo los modelos que se usan",
      allModels: "Ver todos los modelos de la fuente",
      syncError: "No se pudo sincronizar",
      synced: (inserted: string, checked: string) =>
        `Sincronizado: ${inserted} precios nuevos de ${checked} revisados.`,
      lastFailed: "La última sincronización falló",
      keepUsing: "Se siguen usando los últimos precios conocidos",
      noGoodSync: ", aunque no ha habido ninguna sincronización buena todavía",
      fromSync: (date: string) => `, de la sincronización del ${date}`,
      unpricedModels: "Modelos sin precio conocido",
      unpricedNote:
        ". Sus llamadas cuentan tokens pero no coste: no se adivina un precio.",
      readError: "No se pudieron leer los precios",
      empty: "Todavía no hay precios.",
    },
  },
} as const;
